module.exports = __webpack_public_path__ + "img/6.9e47f6a0.png";